import { styled } from '@mui/system';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Palette,
  Link,
} from '@mui/material';
interface PositionDivProps {
  desktop: boolean;
}

interface HeaderAppBarProps {
  elevation: number;
  position: string;
}

const RootDiv = styled('div')({
  flexGrow: 1,
  '& .MuiButton-root': {
    textTransform: 'None',
  },
});
const HeaderAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'elevation' && prop !== 'position',
})<HeaderAppBarProps>(({ elevation, position, theme }) => ({
  top: 0,
  bottom: 'auto',
  height: 64,
  background: '#fff',
  backdropFilter: 'blur(5px)',
  boxShadow: elevation ? '0px 1px 10px rgb(0 0 0 / 12%)' : 'none',
  position: position,
  [theme.breakpoints.up('md')]: {
    height: 'inherit',
  },
  zIndex: 990,
}));
const HeaderToolbar = styled(Toolbar)({
  justifyContent: 'space-between',
  minHeight: 64,
  backgroundColor: 'transparent',
  paddingRight: 0,
  paddingLeft: '12px',
});

const PositionDivLeft = styled('div', {
  shouldForwardProp: (prop) => prop !== 'desktop',
})<PositionDivProps>(({ desktop }) => ({
  flex: 0,
  position: desktop ? 'absolute' : 'unset',
  left: desktop ? 20 : 0,
  zIndex: desktop ? 1 : 0,
}));

const SearchBoxDiv = styled('div')({
  maxWidth: '800px',
});

const PositionDivRight = styled('div', {
  shouldForwardProp: (prop) => prop !== 'desktop',
})<PositionDivProps>(({ desktop }) => ({
  flex: 0,
  position: desktop ? 'absolute' : 'unset',
  right: desktop ? 12 : 0,
  zIndex: desktop ? 1 : 0,
}));

const HeaderLeftDiv = styled('div')({
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
});
const BackIconButton = styled(IconButton)(({ theme }) => ({
  color: (theme.palette as Palette).text.primary,
}));
const HeaderRightComponent = styled('div')({
  display: 'flex',
  alignItems: 'center',
});
const LoginButton = styled(Button)(({ theme }) => ({
  color: (theme.palette as Palette).primary.main,
  borderColor: (theme.palette as Palette).common.white,
  height: 19,
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '24px',
  letterSpacing: '1px',
  maxWidth: 180,
  textDecoration: 'underline',
  [theme.breakpoints.up('md')]: {
    fontSize: 16,
  },
}));
const CancelButton = styled(Button)(() => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '24px',
  letterSpacing: '0.4px',
  color: '#414046',
  paddingRight: 12,
  pointerEvents: 'all',
  textTransform: 'none',
}));
const LoginNameDiv = styled(Button)(({ theme }) => ({
  height: '19px',
  fontSize: '12px',
  marginRight: 15,
  fontWeight: 'normal',
  width: 'max-content',
  color: (theme.palette as Palette).text.primary,
  fontFamily: 'Poppins',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.15px',
  [theme.breakpoints.up('md')]: {
    fontSize: 16,
  },
}));
const MekiLogoLink = styled(Link)({
  cursor: 'pointer',
  marginLeft: 9,
  display: 'flex',
});

export {
  RootDiv,
  HeaderAppBar,
  HeaderToolbar,
  HeaderLeftDiv,
  PositionDivLeft,
  PositionDivRight,
  BackIconButton,
  HeaderRightComponent,
  LoginButton,
  LoginNameDiv,
  MekiLogoLink,
  SearchBoxDiv,
  CancelButton,
};
